import { Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import { AiFillCloseCircle } from 'react-icons/ai'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import TradeCredLogo from '../assets/images/IncomeBazaarLogo.png'
import Button from '../components/button'
import Footer from '../components/footer'
import Sidebar from '../components/sidebar'
import Text from '../components/text'
import Toast from '../components/toast'
import { useAuth } from '../core/AuthContext'
import { useGlobal, useGlobalDispatch } from '../core/GlobalContext'
import { TOAST_DUCK } from '../core/actions'
import { ICICI_BACKEND_API_URL, IDFC_BACKEND_API_URL } from '../core/constants'
import { loadJWT } from '../utils/loadJWT'
import { PAN_FORMAT } from '../utils/validations'
import { Documents } from './financier/Documents'
import * as styles from './root.css'

export default function Root() {
  const {
    logout,
    setAuthState,
    authState: { authenticated, baseUrl },
  } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const {
    financierState: { financier },
  } = useGlobal()
  const { toastDispatch } = useGlobalDispatch()

  const [selectedNav, setSelectedNav] = useState()
  const [pathName, setPathName] = useState(location.pathname)

  const [promotion, setPromotion] = useState({
    title: 'Notice',
    // Set to true when autopopup is necessary
    showBanner: false,
    // Manually change this param
    enableBanner: false,
  })

  useEffect(() => {
    setPromotion({
      title: '',
      // Set to true when autopopup is necessary
      showBanner: true,
      // Manually change this param
      enableBanner: true,
    })
  }, [baseUrl])

  const tableHead = ['Fixed Income', 'Net IRR', 'Secured']
  const tableData = [
    ['TradeCred HNI Scheme', '12%', 'Yes - Secured'],
    ['Corporate FD', '6.5 - 8%', 'No - High Risk'],
    ['Secured NCD/Bonds', '7 - 9%', 'Yes - Depends On Security'],
    ['Un Secured NCD / Bonds', '10 - 12%', 'No - High Risk'],
    ['T Bills', '3 - 5%', 'Yes'],
    ['Bank FD', '6 - 7.25%	', 'Yes - Up to 5 Lakhs'],
  ]

  const HNITable = (
    <table>
      <tr>
        {tableHead.map(title => (
          <th key={title}>
            <Text>{title}</Text>
          </th>
        ))}
      </tr>
      {tableData.map(entry => (
        <tr key={entry[0]}>
          {entry.map(val => (
            <td key={val}>
              <Text>{val}</Text>
            </td>
          ))}
        </tr>
      ))}
    </table>
  )

  const handlePhoneCall = (name, number) => {
    toastDispatch({ type: TOAST_DUCK.SEND_TOAST, payload: { message: `Copied ${name}'s number to clipboard` } })
    navigator.clipboard.writeText(number)
  }

  const handlePromotionClick = () => {
    if (promotion.enableBanner) {
      setPromotion(promo => {
        return { ...promo, ...{ showBanner: !promo.showBanner } }
      })
    }
  }

  const authenticatedRoutes = ['/discover', '/overview', '/portfolio', '/profile']

  useEffect(() => {
    loadJWT(setAuthState)
  }, [])

  useEffect(() => {
    document.getElementById('main').scrollTo(0, 0)
  }, [selectedNav])

  useEffect(() => {
    // Auth True, Redirect to saved Pathname
    // Auth True, Redirect to /discover if pathName doesn't include authenticated routes
    // Auth False, save current pathName to be checked after verification of login
    // Auth False, Redirect to login for any pathname except if pathname includes /register
    if (authenticated) {
      if (authenticatedRoutes.some(route => pathName?.includes(route))) {
        setSelectedNav(authenticatedRoutes.findIndex(route => pathName.includes(route)))
        navigate(pathName)
      } else {
        setSelectedNav(0)
        navigate(authenticatedRoutes[0])
      }
    } else {
      setPathName(location.pathname)
      // Support old referral links as well
      if (location.pathname?.includes('/register') || location.pathname?.includes('onboarding/apply-now')) {
        logout()
        const pathSplits = location.pathname.split('/')
        const referralCode = pathSplits.find(split => PAN_FORMAT.test(split))
        navigate('/register', { state: { referralCode: referralCode } })
      } else {
        navigate('/login')
      }
    }
  }, [authenticated])

  return (
    <div className={authenticated ? (promotion?.title ? styles.layoutPromotion : styles.layout) : undefined}>
      {authenticated && promotion?.title && (
        <div className={styles.promoNavBar} onClick={handlePromotionClick}>
          <a>
            <Text size='0.85' bold>
              {promotion.title}
            </Text>
          </a>
        </div>
      )}
      {/* {authenticated && (
        <div className={styles.nav}>
          <Navbar className={styles.nav} selectedNav={selectedNav} setSelectedNav={setSelectedNav} />
        </div>
      )} */}
      {authenticated ? (
        <div className={styles.sidebarBig}>
          <img src={TradeCredLogo} className={styles.logo} alt='IncomeBazaar Logo' />
          <Sidebar
            selectedNav={selectedNav}
            setSelectedNav={setSelectedNav}
            authenticatedRoutes={authenticatedRoutes}
          />
          {/* <div className={styles.additionalNavLinks}>
            <IconWithLink icon='information-outline' text='FAQ' href={ROUTES.FAQ} setSelectedNav={setSelectedNav} />
            <IconWithLink
              icon='arrow-down-circle-outline'
              text='Reports'
              href={ROUTES.REPORTS}
              setSelectedNav={setSelectedNav}
            />
            <IconWithLink icon='log-out-outline' text='Log Out' onClick={() => logout()} />
          </div> */}
        </div>
      ) : (
        <div className={styles.loginTopBar}>
          <div className={styles.loginLogoContainer}>
            <img src={TradeCredLogo} className={styles.loginLogo} alt='IncomeBazaar Logo' />
          </div>
        </div>
      )}
      <div id='main' className={authenticated ? styles.main : undefined}>
        <div className={styles.content}>
          <Documents>
            <Outlet />
          </Documents>
        </div>
        <Footer />
      </div>
      {/* For Mobile View */}
      {authenticated && (
        <div className={styles.sidebarSmall}>
          <Sidebar
            selectedNav={selectedNav}
            setSelectedNav={setSelectedNav}
            authenticatedRoutes={authenticatedRoutes}
          />
        </div>
      )}

      {/* Initialize Toast universally and trigger toasts using global state */}
      <Toast />

      <Modal
        title={promotion.title}
        open={promotion.showBanner}
        onCancel={handlePromotionClick}
        footer={null}
        width={800}
        closeIcon={<AiFillCloseCircle size='var(--modal-close-icon-size)' />}
        bodyStyle={{ maxHeight: '80vh', overflowY: 'scroll', padding: '1rem 1.5rem' }}>
        {/* <img width={250} height={250} src={promotionIcon} alt={'Promotion Banner Icon'}></img> */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
          <Text>Dear {financier?.financierName || 'Investor'},</Text>
          <>
            <br />
            <Text>
              We request you to deposit funds using your own bank account. The name of the remitter has to match with
              the registered users with us. Non matching of name will result in rejection of funds.
            </Text>
            <br />
            <Text>This is as per banking policy provided to us & same has to be adhered to.</Text>
            <Text>Feel free to get in touch for any queries</Text>
            <div style={{ display: 'flex', gap: 20 }}>
              <Button type='skeleton' handleClick={() => handlePhoneCall('Kunal', '9022936378')}>
                Kunal — 9022936378
              </Button>
              <Button type='skeleton' handleClick={() => handlePhoneCall('Ashish', '8591077156')}>
                Ashish — 8591077156
              </Button>
            </div>
            <br />
          </>

          <Text>Thanks & Regards,</Text>
          <Text>Team IncomeBazaar</Text>
        </div>
      </Modal>
    </div>
  )
}
